/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBankMoney = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12.406 1.086a1 1 0 0 0-.812 0l-9 4A1 1 0 0 0 3 7h18a1 1 0 0 0 .406-1.914l-9-4zM12 3.094 16.288 5H7.712L12 3.094zM3 18V9h2v9H3zm7 4H2v-2h8v2zM7 9v9h2V9H7zm4 2V9h2v2h-2zm8-2v3h2V9h-2zm-4 1V9h2v1h-2zm.593 1.811.532.31 5.735 3.34 1.405.818-1.355.89-1.873 1.23 1.823 1.061 1.405.819-1.355.89-3.628 2.383-.513.337-.531-.31-5.735-3.34-1.442-.84 1.412-.88 1.904-1.188-1.874-1.091-1.405-.818 1.355-.89 3.628-2.384.512-.337zm-.256 6.661-1.398.872 3.761 2.19 1.76-1.156-1.29-.752-.4.263-.532-.31-1.901-1.107zm.326-4.306-1.76 1.156 3.797 2.212 1.76-1.156-3.797-2.212z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBankMoney as BankMoney };
